<template>
  <div class="btn btn-go-top" @click="goTop()">
    <div class="text ff-en-1 fz-14 fw-600 c-100">TOP</div>

    <div class="icon-arrow">
      <img :src="require('@/assets/images/icon-arrow.svg')" alt="go top" />
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export default {
  name: 'BtnGoTop',
  methods: {
    goTop() {
      gsap.to(window, {
        duration: 1,
        scrollTo: { x: 0, y: 0 },
        ease: 'power4.out',
      });
    },
  },
};
</script>

<style lang="scss">
.btn-go-top {
  display: flex;
  align-items: center;

  @include hover {
    .icon-arrow {
      img {
        transform: rotate(-90deg) translateX(3px);
      }
    }
  }

  .icon-arrow {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 32px;
    height: 32px;
    margin-left: 10px;

    border-radius: 8px;
    background-image: var(--gradient-2);

    img {
      height: 13px;
      transform: rotate(-90deg);
      transition: 0.3s;
    }
  }
}
</style>
